import React   , {useEffect, useState } from "react";
import {useSelector, useDispatch} from "react-redux";
import TaskInformation from "../TaskInformation";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import ValidationButton from "../ValidationButton";
import PreviewButton from "../PreviewButton";
import { getTask, unclaimTask, claimTask , completeTask } from "../../../store/action/taskAction";
import * as Actions from "../../../store/action/claimManagement";
import {updateReparationMission} from "../../../store/action/claimManagement";
import {useNavigate, useParams} from "react-router-dom";
import ErrorsAlert from "../../../utils/errorsAlert";
import {validateInput} from "../../../utils/inputValidation";


const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        position: 'relative'
    },
    paper: {
        display: "flex",
        borderRadius: "11px",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    },
    leftSection: {
        flex: 1,
        padding: "40px",
    },
    rightSection: {
        flex: 1,
        padding: "20px",
    },
    inputLabel:{
        color: 'rgba(70, 78, 95, 1)',
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12
    },
    inputTextArea: {
        width: "100%",
        marginBottom: "20px",

    },
    inputContainer: {
        border: 'rgba(243, 246, 249, 1)',
        background: 'rgba(243, 246, 249, 1)',
        width: "100%",
        height: '36px',
        borderRadius: 4,
        marginBottom: "20px",
    },

    //for the preview btn
    previewBtn:{
        position: 'absolute',
        //background: 'rgb(243, 246, 249)',
        right: '30px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    },
    optionText:{
        padding: "5px",
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12
    }
}));

const ReparationMissionAcceptance = () => {
    const { taskId } = useParams();
    const navigate = useNavigate();
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const [motifReparation, setMotifReparation] = useState([]);
    const [reparation, setReparation] = useState([]);
    const [ listSubMotif , setListSubMotif]= useState([]);
    const [ decisionRepairer , setDecisionRepairer]= useState("");
    const [ motif , setMotif]= useState("");
    //const [ subMotif , setSubMotif]= useState("");
    const [ comment , setComment]= useState("");
    const username = localStorage.getItem('username');
    const taskReducer = useSelector((state) => state.taskReducer.taskList.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errors, setErrors] = useState([]);

    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };

    useEffect(() => {
        const fetchTask = async () => {
            try {
                const response = await getTask(taskId, username);
                setTask(response)
                setInfoSinistre(task?.businessKey)
                setVariables(task?.variables)
            } catch (error) {
                console.error(`Error fetching task details: ${error.message}`);
            }
        };
        fetchTask();
    }, [dispatch, taskId, username]);

    const [variables, setVariables] = useState(task?.variables)
    const [infoSinistre, setInfoSinistre] = useState(task?.businessKey)
    const repartionMissionId = task?.variables?.repartionMissionId?.value;

    const fetchTask = async () => {
        try {
            const response = await getTask(taskId, username); 
            setTask(response);
            if(response.assignee === username){
                 
                setIsTaskClaimed(false)
            }else { 
                setIsTaskClaimed(true)
            }
             
        } catch (error) {
            console.error(`Error fetching task details: ${error.message}`);
        }
    };
    const changeDecisionRepairer = (env) => {
        setDecisionRepairer(env);
        if(env === "REFUSAL"){
            setMotif("");
            //setSubMotif("");
        }
    }
    const changeMotif = (env) => {
        setMotif(env);
        const list = motifReparation.find((item) => item._id === env)?.reparationMissionDecisionSubMotif || [];
        setListSubMotif(list);
    }
    const motifReparationData = async () => {
        const motifData = await Actions.getReparationMissionDecisionMotif();
        setMotifReparation(Array.isArray(motifData) ? motifData : [motifData]);

    };

    const getReparationMissionById = async (repartionMissionId) => {
        const repartionData = await Actions.getReparationMissionById(repartionMissionId);
         setReparation(repartionData?.missionNumber)

    };

    const validateInputs = () => {
        const validationErrors = [];

        if (!decisionRepairer) {
            validationErrors.push("Veuillez sélectionner une décision réparateur");
        }

        if (decisionRepairer === "REFUSAL") {
            if (!motif) {
                validationErrors.push("Veuillez sélectionner un motif");
            }
            // if we need to validate subMotif
            // if (listSubMotif.length > 0 && !subMotif) {
            //     validationErrors.push("Veuillez sélectionner un sous-motif");
            // }
        }

        if (comment && comment.trim() !== "") {
            if (!validateInput(comment)) {
                validationErrors.push("Le commentaire contient des caractères non autorisés");
            }
        }
        return validationErrors;
    };

    const ValidationAction = async () => {
        const validationErrors = validateInputs();

        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }
            try {
                // Update the corresponding reparation mission.
                let repartitionObject = {
                    "repairerDecision": decisionRepairer,
                    "comment": comment
                }
                //let variables = {};
                if(decisionRepairer === "REFUSAL"){
                    Object.assign(repartitionObject, {
                        decisionMotif: motif ,
                        //decisionSubMotif : subMotif
                    })
                }
 
                await updateReparationMission(repartionMissionId, repartitionObject)
                console.log("decisionRepairer", decisionRepairer)
                setVariables(
                    variables.reparationMissionStatus= {
                            "value": decisionRepairer,
                            "type": "String"
                    })
                    
                await dispatch(completeTask(taskId, username, variables));
                navigate('/todo-list', { reload: true });
            } catch (error) {
                console.error(error);
                setErrors(["Erreur lors de la validation. Veuillez réessayer."]);
                setOpenErrorDialog(true);
            }
    }

    useEffect(() => {
        fetchTask()
        if(task?.assignee === username){
            setIsTaskClaimed(false)
        }else {
            setIsTaskClaimed(true)
        }
        motifReparationData();
        getReparationMissionById(repartionMissionId)
    }, [repartionMissionId]);


    return (
        <div className={classes.root}>
            <div style={{display: 'flex'}}>
            <div className={classes.mainContent}>
                <TaskInformation taskId={taskId}
                                 onClaimStatusChange={setIsTaskClaimed}
                />
                <Paper className={classes.paper}>
                    <div className={classes.leftSection}>
                        <div>
                            <label className={classes.inputLabel}>N° Mission</label>
                            {/*<input className={classes.inputContainer}  value={task?.variables?.missionNumber?.value}*/}
                            <input className={classes.inputContainer}  value={reparation}
                                      disabled  >
                            </input>
                        </div>
                        <div>
                            <label className={classes.inputLabel}>Décision réparateur</label>
                            <select className={classes.inputContainer} name="decision_reparateur"
                                    onChange={(e) => changeDecisionRepairer(e.target.value)} disabled={isTaskClaimed}
                            >
                                <option className={classes.optionText} value="">Selection Décision</option>
                                <option className={classes.optionText} value="ACCEPTANCE">Acceptation</option>
                                <option className={classes.optionText} value="REFUSAL">Refus</option>
                            </select>
                        </div>
                      {decisionRepairer === "REFUSAL" ? (<>
                        <div>
                                <label className={classes.inputLabel}>Motif</label>
                                <select className={classes.inputContainer} name="motif"
                                        onChange={(e) => changeMotif(e.target.value)} disabled={isTaskClaimed}
                                >
                                    <option className={classes.optionText} value="">Selection Motif</option>
                                    {motifReparation.map((data, index) => (
                                        <option key={index} value={data._id}>{data.label}</option>
                                    ))}
                                </select>
                            </div>
                        {/*{listSubMotif.length > 0 ?*/}
                        {/*    <div>*/}
                        {/*        <label className={classes.inputLabel}>Sous Motif</label>*/}
                        {/*        <select className={classes.inputContainer} name="Submotif" */}
                        {/*        onChange={(e) => setSubMotif(e.target.value)} disabled={isTaskClaimed}>*/}
                        {/*            <option value="">Selection Sous Motif</option>*/}
                        {/*            {listSubMotif.map((data, index) => (*/}
                        {/*                <option key={index} value={data._id}>{data.label}</option>*/}
                        {/*            ))}*/}
                        {/*        </select>*/}
                        {/*    </div> : <></> }*/}
                          </>)
                          : <></>}

                    </div>
                    <div className={classes.rightSection}>
                        <label className={classes.inputLabel}>Commentaire</label>
                        <br />
                        <textarea
                            disabled={isTaskClaimed}
                            className={classes.inputTextArea}
                            onChange={(e) => setComment(e.target.value)}
                            style={{
                                background: "rgba(243, 246, 249, 1)",
                                width: "519px",
                                height: 352,
                                borderRadius: "4px",
                                border: "none",
                                outline: "none",
                                padding: "40px",
                            }}
                        ></textarea>
                    </div>
                </Paper>
            </div>
            <PreviewButton claimData={infoSinistre}  />
        </div>
            <ValidationButton
                //taskId={taskId} 
                handleValidation={() =>isTaskClaimed? null : ValidationAction()} />
            <ErrorsAlert
                open={openErrorDialog}
                errors={errors}
                handleClose={handleClose}
            />
        </div>
    );
};

export default ReparationMissionAcceptance;